module.exports = __webpack_public_path__ + "img/helper.66f3924d.svg";